<script lang="ts">
import { defineComponent } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { SubmitPayload } from '../../components/types'
import Activate from '../../components/Activate.vue'
import { router } from '../../router'

const { useActions: useUserStoreActions } = createNamespacedHelpers('User')

export default defineComponent({
  name: 'ActivatePage',

  components: {
    Activate,
  },

  setup() {

    const { activateUser, validatePerishableToken } = useUserStoreActions(['activateUser', 'validatePerishableToken'])

    const submit = async (payload: SubmitPayload) => {

      await activateUser(payload)

      router.push({
        name: 'LoginPage',
        query: {
          activateSuccess: 'true',
          newSession: 'true',
        },
      })

    }

    return {
      submit,
      validatePerishableToken,
    }

  },
})

</script>

<template>
  <Activate
    :submit="submit"
    :validate-token="validatePerishableToken"
  />
</template>
